import React from 'react';
import logo from '../../images/logo.svg';

const SquireUnavailable = () => (
  <div>
    <div className="u-height-fullvh u-flex o-flexbox--column u-align-items-center u-justify-content-center">
      <img src={logo} alt="Squire Logo" />
      <div>
        <div className="c-heading u-text-center u-mt-">Squire is currently unavailable</div>
        <div className="c-heading u-text-center">Once it becomes available, we'll let you in automatically...</div>
      </div>
      <a className="c-btn c-btn--medium u-mt" href="mailto:support@getsquire.com">Contact Us</a>
    </div>
  </div>
  );


export default SquireUnavailable;
